<template>
  <div class="animated fadeIn">
        <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows the activity logs performed by both admin users and customers</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link to="#" v-show="!loading" @click="fetchData()">
                            <!-- <span class="fa fa-refresh"></span> Refresh Records -->
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <p v-if="loading" style="text-align: center;padding: 20px">
            <span style="font-size: 25px;">
                <i class="fa fa-spinner fa-spin"></i> Loading...
            </span>
        </p>
        <b-row v-else>
            <b-col lg="12" sm="12" md="12" xs="12">
                <b-card-group deck>
                    <b-card header="System Activity Logs">
                        <div v-if="tableData.length < 1">
                            <p style="font-size: 15px;" class="text-center">
                                <i>There are no activity logs this moment.</i>
                            </p>
                        </div>
                        <div v-else>
                            <v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
                        </div>
                        <b-pagination
                          align="left"
                          v-model="response.current_page"
                          :total-rows="response.total"
                          :per-page="response.per_page"
                          @change="getPaginated"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"
                        ></b-pagination>
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { allUsers, getActivityLogs } from '@/services/userService';

export default {
    name: 'activitylogs',
    data: () => {
        return {
            columns: ['id', 'name', 'title', 'description', 'ip_address', 'date'],
            tableData: [],
            loading: false,
            per_page: 20,
            last_page: 0,
            total_pages: 0,
            current_page: 0,
            pageNumbers: [],
            options: {
                headings: {
                    id: 'S/N',
                    name: 'User',
                    title: 'Title',
                    description: 'Description',
                    ip_address: 'IP Address',
                    date: 'Date',
                },
                sortable: ['title', 'ip_adress'],
                filterable: ['title', 'user', 'ip_address', 'date'],
              perPage: 50,
            },
            response: {}
        }
    },
    created () {
        this.fetchData(1);
    },
    methods: {
        async fetchData(page_number) {
            this.loading = true;
            try {
                this.tableData = [];
                const { data: { activities } } = await getActivityLogs(page_number);
                this.response = activities;
                this.setData(activities);
                activities.data.map((activity,index) => {
                    this.tableData.push({
                        id: ++index,
                        name: `${activity.user.first_name} ${activity.user.last_name}`,
                        title: activity.title,
                        description: activity.description,
                        ip_address: activity.ip_address,
                        date: activity.created_at,
                    });
                });
            }
            catch (err) {
                console.log(err);
            }
            finally {
                this.loading = false;
            }
        },
        viewUser(id) {
            this.$router.push(`/customers/${id}`);
        },
        getPaginated(page_number) {
            this.fetchData(page_number);
        },
        setData(data) {
            let total_pages, last_page, current_page;
            let page_numbers = [];

            if(data) {
                total_pages = data.total;
                last_page = data.last_page;
                current_page = data.current_page;
            }
            else {
                total_pages = 0;
                last_page = 0;
                current_page = 0;
            }

            for (let i = 1; i <= Math.ceil(total_pages / data.per_page); i++) {
                page_numbers.push(i);
            }

            this.current_page = current_page;
            this.total_pages = total_pages;
            this.last_page = last_page;
            this.pageNumbers = page_numbers;
        },
    }
}
</script>

<style scoped>
    .pagination {
        margin-top: 25px;
    }

    .pagination span {
        cursor: pointer;
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid #ddd;
    }

    .pagination span.active {
        background-color: #15974b;
        color: white;
        border: 1px solid #15974b;
    }
</style>
